import { useRetryNotification, useUndelivered } from '@/api/studio';
import { formatWhen } from '@/lib/format';

/** Notifications the portal gave up sending to someone after all tries (MK42-5818): shown until sent again. */
export function Undelivered() {
  const { data } = useUndelivered();
  const retry = useRetryNotification();
  if (!data?.length) return null;

  return (
    <section className="mb-10 rounded-lg p-5 shadow-hair" aria-label="Недоставленные уведомления">
      <h2 className="text-sm font-semibold">Недоставленные уведомления: {data.length}</h2>
      <p className="mt-1 text-sm text-muted">Почта не принимала письмо несколько раз подряд. Остальным адресатам оно уже дошло; повтор уйдёт только тем, кому не дошло.</p>
      <ul className="mt-3 divide-y divide-line">
        {data.map((n) => (
          <li key={n.id} className="flex flex-wrap items-center gap-3 py-2.5 text-sm">
            <span className="min-w-0 flex-1">
              {n.text}
              <span className="block text-xs text-muted">
                {formatWhen(n.at)}
                {n.clientName ? `, ${n.clientName}` : ''}, не дошло: {n.recipients.map((r) => r.person.name).join(', ')}
              </span>
            </span>
            <button className="btn-primary h-8" disabled={retry.isPending} onClick={() => retry.mutate(n.id)}>
              Отправить снова
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
